export default __webpack_public_path__ + "static/media/grafico_percentuais.9eb7110a.png";